import DXFWriter from '@tarikjabiri/dxf';

import { Kitchen } from '@rta/rta-blueprint-library';

import { ComponentController } from '@r-core';

export const addMetadata = (drawing: DXFWriter, controller: ComponentController, kitchen: Kitchen): void => {
	const { navigation } = controller;
	const { islandId } = navigation;
	const island = kitchen.design.islands.findById(islandId);
	const isCountertop = navigation.panelId === null;
	const [countertop] = kitchen.design.countertops.filterByIslandId(islandId) ?? [null];
	// const panelText = isCountertop ? 'Countertop' : island.panels.findById(panelId).label;
	const textSize = 2;
	const textSpacing = 0.5;

	const { blueprint } = kitchen.context;

	const baseUrl = import.meta.env.VITE_PUBLIC_URL ?? '';
	const metaText = [
		`${island.sku}`,
		`Url: ${baseUrl}/blueprint/view/${blueprint.email}/${blueprint.submissionDate}`
	];

	if (isCountertop) metaText.push(`Finished Edge: ${countertop.material.edge}`);

	let y = 20 + ((textSize + textSpacing) * metaText.length);

	metaText.forEach((text) => {
		drawing.addText(0, y, textSize, text);
		y -= textSize + textSpacing;
	});

	// drawing.addText(0, 4, 2, `Url: ${process.env.PUBLIC_URL}/blueprint/view/${customerBlueprint.email}/${customerBlueprint.date}`);
	// drawing.addText(0, 6.5, 2, `Finished Edge: ${state.blueprint.material.edge}`);
	// drawing.addText(0, 9, 2, `${state.navigation.selectedPanelText} | ${island.sku}`);
};

